module.exports = __webpack_public_path__ + "static/media/card1.cbe63026.png";